import apiClient from '../utils/apiClient';

export async function getScheduleEmployees(params = {}) {
  const response = await apiClient.get('/api/schedule/employees', { params });
  return response.data;
}

export async function updateScheduleEmployeeVisibility(employeeId, hidden) {
  const response = await apiClient.put(`/api/schedule/employees/${employeeId}/visibility`, { hidden });
  return response.data;
}

export async function getActivityTypes() {
  const response = await apiClient.get('/api/schedule/activity-types');
  return response.data.activityTypes;
}

export async function createBooking(bookingData) {
  const response = await apiClient.post('/api/schedule/bookings', bookingData);
  return response.data;
}

export async function getBookings(startDate, endDate) {
  const response = await apiClient.get('/api/schedule/bookings', {
    params: {
      start_date: startDate,
      end_date: endDate,
    },
  });
  return response.data;
}

export async function deleteBooking(bookingId) {
  const response = await apiClient.delete(`/api/schedule/bookings/${bookingId}`);
  return response.data;
}

export const updateBooking = async (bookingId, data) => {
  const response = await apiClient.put(`/api/schedule/bookings/${bookingId}`, data);
  return response.data;
};

// One change to many bookings: { ids, shift_days } | { ids, activity_type_id } | { ids, delete: true } | { copy_from, copy_to, employee_ids, resource_ids }, or a restore_* undo.
export async function batchBookings(body) {
  const response = await apiClient.post('/api/schedule/bookings/batch', body);
  return response.data;
}
